import { cornType } from '@eigtech/shared-corn';
export const jobResourceType = 'job';
export const jobsServiceCorn = (eventName) => cornType('jobs', eventName);
export const JobsServiceCornSchema = jobsServiceCorn();
